import { TaskStage } from '../types/Task';

const FORCE_ZERO = new Set<string>([
  TaskStage.PROPOSED,
  TaskStage.PLANNED,
  TaskStage.ACTIVE,
  TaskStage.ACTIVE_MARKED_AS_COMPLETE,
]);

/** True when UI should persist actualTotalValue as 0 (early lifecycle). */
export function shouldForceActualTotalValueToZero(status: string | null | undefined): boolean {
  if (!status) return false;
  return FORCE_ZERO.has(status.toUpperCase());
}

/** True when non-zero actual total value overrides are allowed (review / close / finalized). */
export function allowsActualTotalValueOverride(status: string | null | undefined): boolean {
  if (!status) return false;
  const u = status.toUpperCase();
  return u === TaskStage.INTERNAL_REVIEW || u === TaskStage.CLOSED || u === TaskStage.FINALIZED;
}
